/**
 * WelcomeModal — greets a user the first time they land on the home page
 * after finishing the onboarding wizard (Figma MVP-DESIGNES 9617:25325).
 *
 * Thin wrapper over the shared `IllustratedCtaModal` (artwork + pop-out
 * illustration, centered copy, single "Get Started" CTA). This modal swaps
 * the shared defaults for the Figma art:
 *
 * - artwork: the gradient header ("Rectangle" 9617:25360, 600 × 322) exported
 *   from Figma as a 2× PNG and shown full-bleed inside the modal body;
 * - overlay: the astronaut in the bathtub rocket ("Group" 9617:25677) as a
 *   single SVG rendered as a sibling of the modal so the helmet, raised hand
 *   and bubbles pop out above the modal's top edge, exactly like the design.
 *
 * Placement (offsets, overhang) lives in `WelcomeModal.css`.
 */
import React from 'react';

import IllustratedCtaModal, { ILLUSTRATED_CTA_MODAL_WIDTH } from '@/shared/components/IllustratedCtaModal';
import WelcomeAstronaut from '@/shared/assets/illustrations/welcome-astronaut.svg?react';
import welcomeHeader from '@/shared/assets/illustrations/welcome-header.png';

import './WelcomeModal.css';

export const WELCOME_MODAL_WIDTH = ILLUSTRATED_CTA_MODAL_WIDTH;
export const WELCOME_MODAL_TITLE = 'Welcome to the SLM Revolution!';
export const WELCOME_MODAL_BODY = [
    'Get ready to experience zero-latency, hyper-focused Agentic AI.',
    'You now have the power to deploy ultra-efficient Small Language Models tailored exactly to your workflows. Let’s build something incredibly fast.',
].join('\n');
export const WELCOME_MODAL_CTA = 'Get Started';

export default function WelcomeModal({ open = false, onClose }) {
    return (
        <IllustratedCtaModal
            open={open}
            onClose={onClose}
            className="welcome-modal"
            title={WELCOME_MODAL_TITLE}
            body={WELCOME_MODAL_BODY}
            ctaLabel={WELCOME_MODAL_CTA}
            artwork={
                <img
                    src={welcomeHeader}
                    alt=""
                    aria-hidden="true"
                    className="illustrated-cta-modal__artwork welcome-modal__artwork"
                    data-testid="welcome-modal-artwork"
                />
            }
            overlay={
                <WelcomeAstronaut
                    className="illustrated-cta-modal__star welcome-modal__illustration"
                    data-testid="welcome-modal-illustration"
                    aria-hidden="true"
                    focusable="false"
                />
            }
        />
    );
}
